import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactJson from 'react-json-view';
import { TextField, MenuItem } from '@mui/material';
import { Card, CardContent, Typography, Table, TableHead, TableRow, TableCell, TableBody, Box, Button } from '@mui/material';

export default function NotVerifiedNotImportedPage() {
  // ...existing code...
  const handleDelete = async (row) => {
    if (!row._id || !row.client) return;
    await fetch(`${API_BASE_URL}/api/record/${row._id}?client=${row.client}`, {
      method: 'DELETE',
    });
    setData(data => data.filter(r => r._id !== row._id));
    setDeleteConfirm(null);
  };
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [data, setData] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [filters, setFilters] = useState({
    lexiFi_link: '',
    contract_id: '',
    product_type_name: '',
    status: '',
    import_status: '',
    verified: '',
    client: ''
  });
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';

  useEffect(() => {

    fetch(`${API_BASE_URL}/api/contract-summary`)
      .then(res => res.json())
      .then(setData);
  }, []);

  // Filter for Not Verified & Not Imported, then apply header filters
  const filtered = data.filter(row => {
    if (row.import_status === 'imported' || row.status === 'verified') return false;
    const msg = row.verification_message || '';
    if (msg.startsWith('Failed to fetch termsheet') || msg.startsWith('Skipping contract')) return false;
    return (
      (!filters.lexiFi_link || (row.lexiFi_link || '').toLowerCase().includes(filters.lexiFi_link.toLowerCase())) &&
      (!filters.contract_id || (row.contract_id || '').toLowerCase().includes(filters.contract_id.toLowerCase())) &&
      (!filters.product_type_name || (row.product_type_name || '').toLowerCase().includes(filters.product_type_name.toLowerCase())) &&
      (!filters.status || (row.status || '').toLowerCase().includes(filters.status.toLowerCase())) &&
      (!filters.import_status || (row.import_status || '').toLowerCase().includes(filters.import_status.toLowerCase())) &&
      (!filters.verified || (String(row.verified) === filters.verified)) &&
      (!filters.client || (row.client || '').toLowerCase().includes(filters.client.toLowerCase()))
    );
  });

  const handleResetVerified = async (row) => {
    await fetch(`${API_BASE_URL}/api/transactions/${row._id}/reprocess`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ client: row.client })
    });
    // Optionally refresh data
    setData(data => data.map(r => r._id === row._id ? { ...r, verified: false } : r));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Not Verified & Not Imported Contracts</Typography>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Total Not Verified & Not Imported: <b>{filtered.length}</b>
      </Typography>
      <Card>
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TextField label="LexiFi Link" variant="standard" size="small" value={filters.lexiFi_link} onChange={e => setFilters(f => ({ ...f, lexiFi_link: e.target.value }))} />
                </TableCell>
                <TableCell>
                  <TextField label="Contract ID" variant="standard" size="small" value={filters.contract_id} onChange={e => setFilters(f => ({ ...f, contract_id: e.target.value }))} />
                </TableCell>
                <TableCell>
                  <TextField label="Product Type Name" variant="standard" size="small" value={filters.product_type_name} onChange={e => setFilters(f => ({ ...f, product_type_name: e.target.value }))} />
                </TableCell>
                <TableCell>
                  <TextField label="Status" variant="standard" size="small" value={filters.status} onChange={e => setFilters(f => ({ ...f, status: e.target.value }))} />
                </TableCell>
                {/* Removed Import Status filter */}
                <TableCell>
                  <TextField select label="Verified" variant="standard" size="small" value={filters.verified} onChange={e => setFilters(f => ({ ...f, verified: e.target.value }))} style={{ minWidth: 80 }}>
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="true">Yes</MenuItem>
                    <MenuItem value="false">No</MenuItem>
                  </TextField>
                </TableCell>
                <TableCell>
                  {/* No filter for verification message */}
                </TableCell>
                <TableCell>
                  <TextField label="Created At" variant="standard" size="small" value={filters.client} onChange={e => setFilters(f => ({ ...f, client: e.target.value }))} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>LexiFi Link</TableCell>
                <TableCell>Contract ID</TableCell>
                <TableCell>Product Type Name</TableCell>
                <TableCell>Status</TableCell>
                {/* Removed Import Status column header */}
                <TableCell>Actions</TableCell>
                <TableCell>Verified</TableCell>
                <TableCell>Verification Message</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map(row => (
                <React.Fragment key={row._id}>
                  <TableRow
                    hover
                    onClick={() => setExpandedRow(expandedRow === row._id ? null : row._id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <TableCell>
                      <Link to={`/record/${row._id}/${row.client}`} style={{ textDecoration: 'none', color: '#1976d2' }} onClick={e => e.stopPropagation()}>
                        {row.lexiFi_link}
                      </Link>
                    </TableCell>
                    <TableCell>{row.contract_id}</TableCell>
                    <TableCell>{row.product_type_name}</TableCell>
                    <TableCell>{row.status}</TableCell>
                    {/* Removed Import Status cell */}
                    <TableCell>
                      <Box display="flex" gap={1}>
                        <Button size="small" color="error" variant="contained" onClick={e => { e.stopPropagation(); setDeleteConfirm(row._id); }}>Delete</Button>
                        {deleteConfirm === row._id && (
                          <Button size="small" color="warning" variant="outlined" onClick={e => { e.stopPropagation(); handleDelete(row); }}>Confirm Delete</Button>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1}>
                        <span>{row.verified ? 'Yes' : 'No'}</span>
                        <Button size="small" variant="outlined" onClick={e => { e.stopPropagation(); handleResetVerified(row); }}>Reset</Button>
                      </Box>
                    </TableCell>
                    <TableCell>{row.verification_message}</TableCell>
                    <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleDateString() : ''}</TableCell>
                  </TableRow>
                  {expandedRow === row._id && (
                    <TableRow>
                      <TableCell colSpan={8} style={{ background: '#f9f9f9' }}>
                        <ReactJson src={row} name={false} collapsed={false} enableClipboard={true} displayDataTypes={false} />
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </Box>
  );
}
